module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-photo-b58c76515b593c6b7b86dc951dea0b8a.jpg";